import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';
// import 'rxjs/add/operator/filter';
import { filter } from 'rxjs/operators';
// import 'rxjs/add/operator/distinctUntilChanged';
// import 'rxjs/add/operator/filter';

// declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  transaccionConvenioId: string;
  param2: string;
  order: string;
  queryParamsStatus = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {

  this.activatedRoute.queryParams.subscribe(params => {

  });
/*
    const navEndEvents$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );

    navEndEvents$.subscribe((event: NavigationEnd) => {
      gtag('config', 'UA-150930480-1', {
        page_path: event.urlAfterRedirects
      });
    });
    */
  }
}
